export const productTypeOptions = [
    {value: "1", label: "Consumable"},
    {value: "2", label: "Non-Consumable"},
    {value: "3", label: "Limited Period"},
    {value: "4", label: "Subscription"},
]

export const paymentMethodOptions = [
    {value: "PP", label: "PayPal"},
    {value: "GCC", label: "Global Credit Card"},
    {value: "KCC", label: "Inicis (Credit Card)"},
    {value: "KPI", label: "Inicis (PhoneBill)"},
    {value: "DM", label: "Dummy Pay"},
    {value: "FT", label: "Free Trial"},
    {value: "KSP", label: "Samsung Pay KR"},
    {value: "WSP", label: "Samsung Pay WWS"},
    {value: "IWP", label: "PayTM"},
    {value: "KVSPT", label: "Toss"},
]

export const additionalPaymentMethodOptions = [
    {value: "COUPON", label: "Coupon"},
    {value: "SAMSUNG_REWARDS", label: "Samsung Rewards"},
]

export const reflectionStatusOptions = [
    {value: "Y", label: "Reflected"},
    {value: "N", label: "Not Reflected"}
]

export const transactionTypeOptions = [
    {value: "N", label: "Real"},
    {value: "Y", label: "Test"}
]

export const transactionStatusOptions = [
    {value: "202", label: "Completed"},
    {value: "203", label: "Unconfirmed"},
    {value: "306", label: "Refund"},
    {value: "302", label: "Refunded"},
    {value: "206", label: "Refund Reserved"},
    {value: "304", label: "Auto Refunded"},
    {value: "303", label: "Auto Refund Failed"},
]

export const subscriptionStatusOptions = [
    {value: "00", label: "Active"},
    {value: "01", label: "Expired"},
    {value: "02", label: "Canceled by Buyer"},
    {value: "03", label: "Canceled (Payment Failure)"},
    {value: "04", label: "Canceled by CP"},
    {value: "05", label: "Canceled by Admin"},
    {value: "06", label: "Canceled by GDPR"},
    {value: "07", label: "Canceled by Withdrawal"},
    {value: "08", label: "Canceled by Long-term Unused"},
    {value: "09", label: "Canceled by Misuse ID "},
    {value: "10", label: "Canceled by Blacklist ID"},
    {value: "11", label: "Terminated by Admin"},
    {value: "12", label: "Paused by PayTM"},
]